import { useParams, Link, useNavigate } from "react-router-dom";
import locationIcon from "../photo/location.png";
import { useSelector } from "react-redux";
import { Navbar } from "./navbar";
import { Contact } from "./contact";
import { LoadScript, GoogleMap, Marker } from "@react-google-maps/api";
import "../styles/infoProjets.css";

export function InfoProjet() {
    const { id } = useParams();
    const listP = useSelector(s => s.listP) || [];
    const Projet = listP.find(a => a.id == id);
    const navigate = useNavigate();

    if (!Projet) return null;

    const center = {
        lat: Projet.coordonnees?.lat || 33.5892,
        lng: Projet.coordonnees?.lng || -7.6031
    };
    const handleClose = () => navigate(-1);

    return (
        <div className="projet-detail-page">
            <Navbar />

            <div className="projet-content-wrapper">
                <button className="back-link" onClick={handleClose} style={{ background: 'none', border: 'none', cursor: 'pointer', marginTop: '20px', marginLeft: '20px' }}><span>←</span> Retour aux projets</button>


                <div className="info-projet-container">
                    <img
                        src={Projet.imageProjet || ''} 
                        alt={Projet.nomProjet}
                        className="project-hero-img"
                    />

                    <div className="project-inner-body">
                        <p className="project-title-top">{Projet.nomProjet}</p>

                        <div className="project-info-grid">
                            {/* Left Card: Project Info */}
                            <div className="info-card">
                                <h5>Informations du projet</h5>
                                <table className="info-table">
                                    <tbody>
                                        <tr>
                                            <td>Client:</td>
                                            <td>{Projet.societeConception}</td>
                                        </tr>
                                        <tr>
                                            <td>Partenaire:</td>
                                            <td>{Projet.societeRéalisation}</td>
                                        </tr>
                                        <tr>
                                            <td>Date:</td>
                                            <td>{Projet.annee}</td>
                                        </tr>
                                        <tr>
                                            <td>Surface:</td>
                                            <td>{Projet.surface}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            {/* Right Card: Location */}
                            <div className="info-card">
                                <h5>Localisation</h5>
                                <div className="location-header">
                                    <img src={locationIcon} alt="location" />
                                    <span>{Projet.location}</span>
                                </div>
                                <div className="google-map-wrapper">
                                    <LoadScript googleMapsApiKey="AIzaSyCRpJROy3JDpFFoYD04HZQ5iZ78laiF_oU">
                                        <GoogleMap className="google-map"
                                            mapContainerStyle={{ width: "100%", height: "100%", borderRadius: "10px" }}
                                            center={center}
                                            zoom={15}
                                        >
                                            <Marker position={center} />
                                        </GoogleMap>
                                    </LoadScript>
                                </div>
                            </div>
                        </div>

                        {/* Bottom Card: Description */}
                        <div className="description-card">
                            <h5>Description</h5>
                            <p>{Projet.description}</p>
                        </div>
                    </div>
                </div>
            </div>
            {/* <Contact /> */}
        </div>
    );
}

